import axios from 'axios'
import ApplicationController from '../application_controller.js'
import State from './state.js'

export default class InvoiceIndexController extends ApplicationController {

  connect() {
    State.editor_opened = false
  }

  new_form(e) {
    e.preventDefault()

    if (!State.editor_opened) {
      axios.get(e.target.getAttribute('href')).then(response => {
        e.target.closest('fieldset').querySelector('div.table .thead').insertAdjacentHTML('afterend', response.data)
        State.editor_opened = true
      })
    }
  }

}
